import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getResellerProfile = () => {
    return axios.get(`${BASE_URL}/api/profile/reseller-profile`);
  };
  export const updateResellerProfile = (body) => {
    return axios.post(`${BASE_URL}/api/profile/update-profile`,body);
  };